const fragmentShader = `
precision highp float;

varying vec2 vUv;
varying float vColorRand;
varying float vProgress;
varying vec3 vNormal;
varying vec3 vWorldPosition;
varying vec3 vLookDirection;

uniform vec3 colorA;
uniform vec3 colorB;
uniform float particleOpacity;

uniform sampler2D particleTexture;

float fresnel(vec3 eyeVector, vec3 worldNormal) {

	return pow( 1.0 + dot( eyeVector, worldNormal ), 3.0 );

}


void main() {

  float f = min( 1.0, fresnel( vLookDirection, vNormal ) );

  float m = 1.0 - step( 0.5, distance( vUv, vec2( 0.5 ) ) );

  vec3 col = mix( colorA, colorB, 1.0 );
  col = mix( col, colorA, vProgress );

  col = mix( colorA, colorB, vColorRand );

  vec4 particleTex = texture2D( particleTexture, vUv );

  particleTex.rgb *= col * 2.0;

  gl_FragColor = particleTex * particleOpacity;

}`;

export default fragmentShader;
